import { NavLink, Outlet } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api, type MeResponse } from '../api/client'

const link = ({ isActive }: { isActive: boolean }) =>
  `rounded-lg px-2.5 py-[9px] font-semibold ${isActive ? 'bg-ink-600 ring-1 ring-ink-400' : 'hover:bg-ink-600'}`

/** The Accounting area: its own shell, like the Subscriber Desk. */
export function AccountingLayout() {
  const { data: me } = useQuery<MeResponse>({ queryKey: ['me'], queryFn: () => api.get<MeResponse>('/api/me'), staleTime: 60_000, retry: false })
  if (!me) return null
  return (
    <div className="min-h-screen bg-ink-900 text-paper font-ui text-[14px] md:flex print:block print:bg-white print:text-black">
      <nav aria-label="Accounting" className="flex shrink-0 flex-col gap-2 border-b border-ink-500 bg-ink-700 px-3.5 pb-6 pt-6 md:min-h-screen md:w-[240px] md:border-b-0 md:border-r print:hidden">
        <span className="px-2 text-[11px] font-bold uppercase tracking-[0.14em] text-amber-glow">AAMCirc</span>
        <span className="px-2 pb-3 font-serif text-[23px] font-medium">Accounting</span>
        <NavLink to="/accounting" end className={link}>Monthly closes</NavLink>
        <NavLink to="/accounting/history" className={link}>SimpleCirc history</NavLink>
        <NavLink to="/accounting/accounts" className={link}>QuickBooks accounts</NavLink>
        {me.role === 'admin' && <NavLink to="/" className={link}>Back to the AAMCirc console</NavLink>}
      </nav>
      <main className="min-w-0 flex-1 px-4 py-6 md:px-8"><Outlet /></main>
    </div>
  )
}
